import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          fontSize: '18px',
          color: 'white',
        }}
      >
        Loading...
      </div>
    );
  }

  if (!user) return <Navigate to="/invalid-link" replace />

  return children;
}

export default PrivateRoute;
